import React from "react";

export default function Decoration() {
  return <div>Decoration</div>;
}
